<template>
  <div>
    <information-list :lists="lists"></information-list>
    <v-divider></v-divider>
    <h4 class="subheader">{{ $t('user.profile.subtitles.activity') }}</h4>
    <Activities :userId="user.id"></Activities>
    <v-divider></v-divider>
    <form @submit.prevent="submit()">
      <v-card-text>
        <rich-text-input
          v-model="note"
          :config="{
            label: $t('user.profile.note'),
            key: 'note',
            required: true
          }">
        </rich-text-input>
      </v-card-text>
      <v-card-row actions>
        <v-btn
          type="submit"
          :loading="loading"
          primary light>
          {{ $t('user.profile.save') }}
        </v-btn>
      </v-card-row>
    </form>
  </div>
</template>

<script>
  import InformationList from '@/components/InformationList.vue'
  import { RichTextInput } from '@/components/inputs'
  import Activities from '@/components/Activities'
  import user from '@/mixins/user'
  export default {
    components: {
      InformationList,
      RichTextInput,
      Activities
    },
    mixins: [user],
    data () {
      return {
        note: this.user.note
      }
    },
    computed: {
      personalInformations () {
        return [
          { key: 'nickname', value: this.user.nickname, icon: 'face' },
          { key: 'firstName', value: this.user.first_name, icon: 'account_box' },
          { key: 'lastName', value: this.user.last_name, icon: 'assignment_ind' }
        ]
          .map(e => ({ ...e, title: this.$t(`user.profile.item.${e.key}`) }))
      },
      contactInformations () {
        return [
          { key: 'email', value: this.user.email, icon: 'email' },
          { key: 'phone', value: this.user.phone, icon: 'phone' }
        ]
          .map(e => ({ ...e, title: this.$t(`user.profile.item.${e.key}`) }))
      },
      otherInformations () {
        return [
          { key: 'minutes', value: this.user.phone_seconds_available, type: 'minute', icon: 'timer' },
          { key: 'createdAt', value: this.user.created_at, type: 'date', icon: 'event' },
          { key: 'lastConnection', value: this.user.current_sign_in_at || this.user.created_at, type: 'date', icon: 'update' },
          this.user.locked_at ? { key: 'lockedAt', value: this.user.locked_at, type: 'date', icon: 'lock_outline' } : null,
          this.user.risky_at ? { key: 'riskyAt', value: this.user.risky_at, type: 'date', icon: 'warning' } : null
        ]
          .filter(e => e)
          .map(e => ({ ...e, title: this.$t(`user.profile.item.${e.key}`) }))
      },
      lists () {
        return [
          { title: this.$t('user.profile.subtitles.personal'), items: this.personalInformations },
          { title: this.$t('user.profile.subtitles.contact'), items: this.contactInformations },
          { title: this.$t('user.profile.subtitles.other'), items: this.otherInformations }
        ]
      }
    },
    methods: {
      submit () {
        this.save({
          id: this.user.id,
          data: {
            note: this.note
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/Profile.vue